import React from 'react';
import { Divider, Icon, Tooltip } from 'antd';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import DOMPurify from 'dompurify';
import { selectedInfoSelector } from '../../store/selectors';
import InfoActions from './components/InfoActions/InfoActions';
import { formatDate, getInfoTypeIcon } from '../../utils';
import Author from '../Author/Author';
import ViewAndReactions from './components/ViewAndReactions/ViewAndReactions';
// import OgContainer from './components/OgContainer/OgContainer';
import AttachmentContainer from './components/AttachmentsContainer/AttachmentsContainer';
import BindsContainer from './components/BindsContainer/BindsContainer';
import HeaderImg from './components/HeaderImg/HeaderImg';
import styles from './Information.module.scss';
import { typeIds } from '../../constants/common';

const Information = ({ className }) => {
  const info = useSelector(selectedInfoSelector);
  const allowReclameApprove = useSelector(
    (state) => state.authentication.userInfo.AllowReclameApprove
  );

  const hasNotActionsBtn =
    info?.type?.id === typeIds.advertisement && !allowReclameApprove;

  if (!info) {
    return null;
  }

  const datePub = formatDate(info.datePub);
  const dateEnd = formatDate(info.dateEnd);

  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.infoContainer}>
        <header className={styles.header}>
          <span className={styles.infoNum}>{info.id}</span>
          {!hasNotActionsBtn && <InfoActions />}
        </header>
        <HeaderImg infoId={info?.id} />
        <div className={styles.titleWithIcon}>
          <Tooltip title={info.type.name}>
            {getInfoTypeIcon(info.type.id, 45)}
          </Tooltip>
          <div>
            <h3 className={styles.title}>{info.title}</h3>
            <span className={styles.companyName}>{info.serviceCompany}</span>
          </div>
        </div>

        <div className={styles.metaWrap}>
          <span>
            {datePub} - {dateEnd}
          </span>
          {info.worker && (
            <>
              <Divider type="vertical" />
              <div className={styles.workerWrap}>
                <Icon
                  type="user"
                  className={styles.icon}
                />
                <Author author={info.worker} />
              </div>
            </>
          )}
        </div>

        <div
          className={styles.infoText}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(info.text.replace(/\n/g, '<br />')),
          }}
        />

        <ViewAndReactions />
        {/* <OgContainer text={info.text} /> */}
      </div>
      {info?.hasAttachment && <AttachmentContainer info={info} />}
      <BindsContainer infoId={info?.id} />
    </div>
  );
};

export default Information;
